var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-field-container",class:{'-open': _setup.isSearchOpen }},[_c(_setup.SearchField,_vm._g({ref:"searchField",staticClass:"u-flex u-z-1",attrs:{"autosuggest":true,"placeholder":"","input-class":"u-bg-white"}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }